import React from "react";
import { ContactForm } from "./ContactForm";
import { useContext, useCallback, useMemo, useState } from "react";
import { SubmitHandler, useForm, FormProvider } from "react-hook-form";
import { IContactData } from "../../components/interface";
import { timeCurrentIso8601 } from "../../utils";
import { useAddContactData } from "./useContactData";
import { TankyouContact } from "../Tankyou";
export const Contact = () => {
  const [formPush, setFormPush] = useState(false);
  const [cancel, setCancel] = useState(false);

  const { mutate } = useAddContactData({
    cognitoIdToken: "new",
  });

  const methods = useForm<IContactData>({
    mode: "onSubmit",
    reValidateMode: "onChange",
    defaultValues: {
      mail: "",
      type: "inquiry-box",
      tel: "",
      cp: "",
      username: "",
      detail: "",
      consent_date: "",
      del_flag: 0,
      created_at: timeCurrentIso8601(),
      updated_at: timeCurrentIso8601(),
    },
  });

  const onSubmit: SubmitHandler<IContactData> = (data) => {
    console.log("submit", data);
    mutate({
      cognitoIdToken: "update",
      params: JSON.stringify(data),
    });
    // setFormPush
    setFormPush(true);
  };

  const refreshPage = () => {
    window.location.reload();
  };

  if (formPush === false) {
    return (
      <>
        <FormProvider {...methods}>
          <ContactForm
            onSubmit={onSubmit}
            open={formPush}
            onClose={() => {
              setCancel(true);
              refreshPage();
            }}
          />
        </FormProvider>
      </>
    );
  } else {
    return (
      <>
        <TankyouContact />
      </>
    );
  }
};
